import styled from 'styled-components';

import { VFlex } from '@/components/base';
import Transition from '@/components/Common/Transition';
import ChartController from '@/features/(charts)/chart-controller/ui/chart-controller';
import { customScrollbar } from '@/styles/style';

type Props = {
  chartInfo: ChartContextProps;
};

export default function ChartDetailControllerSection({ chartInfo }: Props) {
  return (
    <ChartContollerSectionStyle className="flex chart-detail-body-section">
      <VFlex style={{ flexShrink: 0, width: '100%' }}>
        <Transition
          status={chartInfo.initialized}
          style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
        >
          <ChartController chartInfo={chartInfo} />
        </Transition>
      </VFlex>
    </ChartContollerSectionStyle>
  );
}

const ChartContollerSectionStyle = styled.div`
  width: 460px;
  background-color: ${(props) => props.theme.colors.gray100};
  overflow: auto;
  scrollbar-gutter: stable;
  ${customScrollbar};
`;
